export default {
	controls: {
		next: "Siguiente",
		prev: "Anterior",
		done: "Finalizar",
		progressSeparator: "de",
	},
	welcome: {
		title: "¡Bienvenido a ORI!",
		description: "ORI es un sistema de gestión espiritual para templos. Vamos a hacer un tour rápido por los módulos del sistema para que conozcas todo lo que está disponible.",
		recommended: "Altamente recomendado",
		start: "Iniciar Tour Guiado",
		skip: "Omitir por ahora",
	},
	helpPanel: {
		title: "Ayuda de la Página",
		rewatchTour: "Ver Tour Guiado de nuevo",
	},
	guided: {
		assistant: {
			title: "Asistente virtual",
			description: "Y siempre que necesites ayuda, habla con el asistente. Responde dudas, te muestra dónde hacer clic y te ayuda a configurar el terreiro paso a paso — solo haz clic en este botón cuando quieras.",
		},
		dashboard: {
			title: "Dashboard",
			description: "Página inicial del sistema. Aquí ves un resumen rápido: tus datos, el ritual activo, los agendados, gráficos rápidos y los cumpleañeros.",
		},
		consultants: {
			title: "Consultantes",
			description: "Personas que frecuentan el templo para recibir atención espiritual. Registra, busca y gestiona todos los consultantes.",
		},
		mediums: {
			title: "Médiums",
			description: "Miembros del cuerpo mediúmnico del templo. Gestiona el registro de médiums, funciones y líneas espirituales. Agrega una jornada al consultante para integrarlo a la corriente.",
		},
		journeyStages: {
			title: "Etapas de la Jornada",
			description: "Etapas por las que una persona pasa en el templo (ej: Visitante, Iniciado, Desarrollado). Cada persona puede estar en una etapa.",
		},
		functions: {
			title: "Funciones",
			description: "Roles que los médiums ejercen en los rituales (ej: Cambono, Ogã, Pai/Mãe de Santo). Asigna funciones a las personas.",
		},
		memberGroups: {
			title: "Grupos",
			description: "Organiza personas en grupos para facilitar la gestión. Crea grupos por finalidad (ej: Grupo de Estudio, Corriente de Curación) y asigna miembros.",
		},
		spiritualLines: {
			title: "Líneas Espirituales",
			description: "Líneas espirituales que trabajan en la casa. Ej: Línea de Pretos Velhos, Línea de Caboclos, Línea de Niños.",
		},
		guides: {
			title: "Guías Espirituales",
			description: "Entidades que atienden a las personas en el templo. Registra los guías y asócialos a las personas para mantener el registro espiritual.",
		},
		orixas: {
			title: "Orixás",
			description: "Divinidades veneradas en el templo. Registra los orixás y asócialos a las personas para registrar la corona y las conexiones espirituales.",
		},
		attendanceTypes: {
			title: "Tipos de Ficha",
			description: "Categorías de atención disponibles (ej: Consulta, Pase, Descarga). Créalas según la necesidad de tu casa. Estas fichas luego se vinculan a los rituales.",
		},
		ritualTypes: {
			title: "Tipos de Rituales",
			description: "Categorías de rituales practicados en el templo (ej: Gira de Caboclo, Sesión de Curación). Cada ritual creado se asocia a un tipo.",
		},
		rituals: {
			title: "Rituales",
			description: "Rituales realizados en el templo. Crea, inicia, gestiona y cierra rituales. Cada ritual genera fichas, llamadas y registros de atención.",
		},
		financialDashboard: {
			title: "Financiero",
			description: "Panel financiero del templo. Acompaña ingresos, gastos y el saldo general. Visión consolidada de todo el movimiento financiero.",
		},
		financialFunds: {
			title: "Cajas",
			description: "Gestiona las cajas/fondos del templo. Crea fondos, registra contribuciones y acompaña los movimientos de ingreso.",
		},
		financialMovements: {
			title: "Movimientos",
			description: "Historial completo de todos los movimientos financieros del templo. Filtra por período, caja, tipo y estado.",
		},
		financialReports: {
			title: "Informes Financieros",
			description: "Informes detallados de la situación financiera. Cierres mensuales, balances y análisis por período.",
		},
		templeSettings: {
			title: "Configuraciones del Templo",
			description: "Edita los datos del templo, contacto, dirección, funcionamiento e identidad visual. Configura impresión, email, atención y financiero.",
		},
		templeUsers: {
			title: "Usuarios",
			description: "Mira quién tiene acceso al sistema, sus roles (Propietario, Admin, Miembro) y estado de actividad.",
		},
		templeInvites: {
			title: "Invitaciones",
			description: "Envía invitaciones por email para que nuevas personas accedan al sistema. Acompaña el estado de cada invitación.",
		},
		wisdomQuotes: {
			title: "Frases de Sabiduría",
			description: "Gestiona frases de sabiduría mostradas en el dashboard y mensajes del templo. Agrega, edita o desactiva frases.",
		},
		billing: {
			title: "Plan y Suscripción",
			description: "Consulta el plan actual del templo, período de prueba e información de suscripción.",
		},
		displayMessages: {
			title: "Mensajes del Display",
			description: "Gestiona los mensajes mostrados en ORI TV. Crea avisos, recordatorios y comunicados para el display del templo.",
		},
		import: {
			title: "Importación",
			description: "Importa datos masivamente al sistema. Envía planillas con registros de personas para agilizar la migración.",
		},
		support: {
			title: "Soporte",
			description: "Canal directo con el equipo de ORI. Abre tickets para dudas, sugerencias o problemas técnicos y acompaña el estado.",
		},
	},
	pages: {
		Dashboard: "El Dashboard es la página inicial del sistema. Aquí ves un resumen rápido: tus datos, el ritual activo, los agendados, gráficos rápidos y los cumpleañeros.",
		Consultants: "Los consultantes son las personas que frecuentan el templo para recibir atención espiritual. Aquí registras, buscas y gestionas todos los consultantes.",
		Mediums: "Los médiums son los miembros del cuerpo mediúmnico del templo. Aquí gestionas el registro de todos los médiums, incluyendo funciones y líneas espirituales.",
		SpiritualLines: "Líneas espirituales que trabajan en la casa. Ej: Línea de Pretos Velhos, Línea de Caboclos, Línea de Niños.",
		Guides: "Los guías espirituales son entidades que atienden a las personas en el templo. Registra los guías y asócialos a las personas.",
		Orixas: "Los orixás son divinidades veneradas en el templo. Registra los orixás y asócialos a las personas para registrar la corona y las conexiones espirituales.",
		RitualTypes: "Los tipos de rituales definen las categorías de rituales practicados en el templo. Cada ritual creado se asocia a un tipo.",
		Rituals: "Rituales realizados en el templo. Aquí creas, inicias, gestionas y cierras los rituales. Cada ritual genera fichas, llamadas y registros de atención.",
		JourneyStages: "Las etapas de la jornada representan los estadios por los que una persona pasa en el templo. Cada persona puede estar en una etapa.",
		Functions: "Las funciones definen los roles que los médiums ejercen en los rituales. Asigna funciones a las personas para organizar el cuerpo mediúmnico.",
		MemberGroups: "Los grupos permiten organizar personas por finalidad. Crea grupos, agrega miembros y gestiona asignaciones colectivas.",
		AttendanceTypes: "Categorías de atención disponibles (ej: Consulta, Pase, Descarga). Créalas según la necesidad de tu casa. Estas fichas luego se vinculan a los rituales.",
		FinancialDashboard: "Panel financiero del templo. Acompaña ingresos, gastos y el saldo general. Visión consolidada de todo el movimiento financiero.",
		FinancialFunds: "Gestiona las cajas/fondos del templo. Crea fondos, registra contribuciones y acompaña los movimientos de ingreso.",
		FinancialMovements: "Historial completo de todos los movimientos financieros del templo. Filtra por período, caja, tipo y estado.",
		FinancialReports: "Informes detallados de la situación financiera. Cierres mensuales, balances y análisis por período.",
		TempleSettings: "Las configuraciones del templo permiten editar los datos, contacto, dirección, funcionamiento e identidad visual.",
		TempleUsers: "Gestión de usuarios del templo. Mira quién tiene acceso al sistema, sus roles y estado de actividad.",
		TempleInvites: "Sistema de invitaciones del templo. Envía invitaciones por email para que nuevas personas accedan al sistema.",
		WisdomQuotes: "Frases de sabiduría mostradas en el dashboard y mensajes del templo. Agrega, edita o desactiva frases.",
		Billing: "Consulta el plan actual del templo, período de prueba e información de suscripción.",
		DisplayMessages: "Gestiona los mensajes mostrados en ORI TV. Crea avisos, recordatorios y comunicados para el display del templo.",
		Import: "Importa datos masivamente al sistema. Envía planillas con registros de personas para agilizar la migración.",
		Support: "Canal directo con el equipo de ORI. Abre tickets para dudas, sugerencias o problemas técnicos y acompaña el estado.",
	},
};
